import "./JobHeaderComponent.scss";
import ButtonComponent from "../../../components/button-component/ButtonComponent";
import {useCallback, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {closeSignUpModal, openSignUpModal} from "../../../store/actions/meta.action";
import {StateParams} from "../../../store/reducers";
import ModalComponent from "../../../components/modal/ModalComponent";
import SignUpComponent from "../../auth/sign-up/SignUpComponent";
import UserMenuComponent from "../user-menu/UserMenuComponent";
import { Skeleton } from "antd";
import FlexOs from "../../../assets/images/FlexOs.svg";
interface JobHeaderComponentProps{

}

const JobHeaderComponent=(props:JobHeaderComponentProps)=>{
    const dispatch=useDispatch();
    const {isSignUpVisible,isCustomersConfigLoading,currentCustomerConfig} = useSelector((state: StateParams) => state.meta);
    const {token}=useSelector((state:StateParams)=>state.auth);
    const [resumeFile,setResumeFile]=useState<any>(null);
    const currentCustomerUniqueId = currentCustomerConfig?.customer_unique_id;

    const isEclatLogo = currentCustomerUniqueId === 'eclaths';
    const isLarkmsLogo = currentCustomerUniqueId === 'larkms';
   
    const handleSignUp=useCallback(()=>{
            dispatch(openSignUpModal())
    },[dispatch]);

    return (
        <>
            <ModalComponent
                width={600}
                open={isSignUpVisible}
                onCancel={()=> {
                    dispatch(closeSignUpModal());
                    setResumeFile(null);
                }}
                centered={true}
                footer={null}
                // destroyOnClose={true}
            >
                <SignUpComponent resumeFile={resumeFile} setResumeFile={setResumeFile}/>
            </ModalComponent>
            <div className={'job-header-component'}>
                <div className={isEclatLogo ? 'job-eclat-logo-wrapper' : isLarkmsLogo ? 'job-larkms-logo-wrapper' : 'job-header-logo-wrapper'}>
                    {isCustomersConfigLoading ?
                        <Skeleton.Avatar
                            active
                            size={30}
                            shape="square"
                            style={{ width: 150, height: 30 }}
                        /> :
                        <img
                            src={currentCustomerConfig?.customer_logo?.file_url  || FlexOs}
                            alt={"logo"}
                            className={'job-board-logo'}
                        />
                    }
                </div>
                {token ?
                    <UserMenuComponent/>
                    :
                    <div className={'job-header-btn-wrapper'}>
                        <ButtonComponent
                            color={'primary'}
                            variant={'outlined'}
                            size={'large'}
                            onClick={handleSignUp}
                        >
                            Submit Resume
                        </ButtonComponent>
                    </div>
                }
            </div>
        </>
    )
}


export default JobHeaderComponent;